import { render, staticRenderFns } from "./TransporterList.vue?vue&type=template&id=448c75d8"
import script from "./TransporterList.vue?vue&type=script&lang=js"
export * from "./TransporterList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports